<template>
  <ListView
    modelName="PartneredTenant"
    perm="system.menu_partnered_tenant"
    :items.sync="items"
    :params.sync="params"
    title="menu_partnered_tenant"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="partnered_tenant"
    :gridCaptions="['テナントID', 'テナント名称','管理者ID','管理者氏名','利用ステータス','有償利用開始日']"
    :gridWidths="[250, 250, 250, 250, 250, 250]"
    :exportQuery="exportQuery"
    class="cx_partnered_tenant"
    :comparer="(a,b)=>a.id == b.id"            
    tooltip="顧問先テナントの一覧です。"
  >
    <!-- 明細項目の配置 -->
    <GridItem slot="grid0" slot-scope="{ item }"><span class="cx_link_item" @click="onClick(item.tenantId)"> {{ item.tenantId }}</span></GridItem>  
    <!-- <GridItem slot="grid0" slot-scope="{ item }">{{ item.tenantId }}</GridItem> -->
    <GridItem slot="grid1" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.tenantName }}</GridItem>
    <GridItem slot="grid2" slot-scope="{ item }">{{ item.adminId }}</GridItem>
    <GridItem slot="grid3" slot-scope="{ item }">{{ item.adminName }}</GridItem>
    <GridItem slot="grid4" slot-scope="{ item }">{{ item.paymentStatus | paymentStatusFlags }}</GridItem>
    <GridItem slot="grid5" slot-scope="{ item }">{{ item.paidStartDate | date }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }"><ListViewMenuBar :listView="listView" :add="false" :edit="true" :del="false" :copy="false"/></template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search  :listView="listView">
        <FilterBox title="テナントID" :value.sync="params.tenantId" placeholder="Enter ID" @click="handler" />
        <FilterBox title="テナント名称" :value.sync="params.tenantName" placeholder="Enter Name" @click="handler" />
      </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報']" :tabTooltips="[null]"  :spEditVisible="false">
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <template slot="left">
              <TextBox title="テナントID" :editor="editor" :value.sync="item.tenantId" :enabled="false" tooltip="顧問先テナントのIDです。"/>
              <TextBox title="テナント名称" :editor="editor" :value.sync="item.tenantName" :enabled="false" tooltip="顧問先テナントの名称です。"/>
              <TextBox title="管理者ID" :editor="editor" :value.sync="item.adminId" :enabled="false" tooltip="顧問先の管理者のIDです。"/>
              <TextBox title="管理者名称" :editor="editor" :value.sync="item.adminName" :enabled="false" tooltip="顧問先の管理者の氏名です。"/>
              <AutoComplete title="利用ステータス" :editor="editor" :value.sync="item.paymentStatus" list="paymentStatusFlags" :enabled="false" tooltip="顧問先テナントの利用状態です。トライアルか有償利用のいずれかで、解約済みのテナントは表示されません。" />
              <Calendar title="有償利用開始日" :editor="editor" :value.sync="item.paidStartDate" :enabled="false" tooltip="顧問先テナントの有償利用開始日です。"/>
            </template>
          </EditPanel>
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class GroupView extends Vue {
  public items: Common.PartneredTenant[] = new Array();
  public params: Common.PartneredTenantQuery = new Common.PartneredTenantQuery();
  public exportQuery = new Common.ExportQuery('顧問先テナント', this.params);

  public sortOptions: any = [
    { value: 'tenantid', text: 'テナントID' },
    { value: 'tenantname', text: 'テナント名称' },
  ];

  //テナントに遷移
  public onClick(tenantId:string){        
    if (this.$api.enviromentFlag == Common.enviromentFlags.production) window.open(String.format("https://{0}.s-flow.net",tenantId), '_blank');       
    else window.open(String.format("https://{0}.s-flow-stage.net",tenantId), '_blank');                     
  }

  public created(){
  }  
}
</script>